export var WorkspaceSortField;
(function (WorkspaceSortField) {
    WorkspaceSortField["WORKSPACE_SORT_FIELD_CREATED_AT"] = "createdAt";
    WorkspaceSortField["WORKSPACE_SORT_FIELD_NAME"] = "name";
    WorkspaceSortField["WORKSPACE_SORT_FIELD_REGION"] = "region";
})(WorkspaceSortField || (WorkspaceSortField = {}));
